<template>
    <div class="el-table el-table--fit el-table--border">
        <div class="el-table__body-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body " style="width:100%;">
                <tbody>
                    <tr>
                        <td ref="tdlbl_教师编号" class="el-table__cell tdlbl tdw13" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'teacherId'" class="field">教师编号</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="teacherId"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入教师编号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'教师编号','propName':'teacherId','propType':'String','textFormatter':'textfield','valueMaxLength':20,'valueMinLength':null,'model':'vo.teacherId','option':[]}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_入职日期" class="el-table__cell tdlbl tdw13" colspan="1">

                            <span v-field-lbl="'entryDate'" class="field">入职日期</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item ref="entryDate" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'日期选择框','propName':'entryDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'entryDate','iconName':'rqxzk','model':'vo.entryDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}" :vo="vo" :can-edit="canEdit" />
                        </td>
                        <td ref="tdlbl_转正日期" class="el-table__cell tdlbl tdw13" colspan="1">

                            <span v-field-lbl="'confirmationDate'" class="field">转正日期</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item ref="confirmationDate" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'日期选择框','propName':'confirmationDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'confirmationDate','iconName':'rqxzk','model':'vo.confirmationDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}" :vo="vo" :can-edit="canEdit" />
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_所属单位" class="el-table__cell tdlbl tdw13" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'unitName'" class="field">所属单位</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="unitName"
                                :field="{'defaultValue':'请选择','elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请选择','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'所属单位','propName':'unitName','propType':'String','textFormatter':'textfield','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'unitname','iconName':'puwb','model':'vo.unitName','option':[],'formTdAlign':'text-left','dialog':1,'dialogType':'rootorg','dialogOrgLevel':'','dialogMultiple':false,'autocomplete':'off','showWordLimit':false,'valueIdsField':'vo.unitId','formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_工作方式" class="el-table__cell tdlbl tdw13" colspan="1">

                            <span v-field-lbl="'workMethod'" class="field">工作方式</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="workMethod"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：借调\n1：外派','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择工作方式','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'工作方式','propName':'workMethod','propType':'String','textFormatter':null,'valueMaxLength':4,'valueMinLength':null,'model':'vo.workMethod','option':[{'value':'0','name':'借调'},{'value':'1','name':'外派'}],'optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_借调/外派日期" class="el-table__cell tdlbl tdw13" colspan="1">

                            <span v-field-lbl="'dispatchDate'" class="field">借调/外派日期</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="dispatchDate"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'借调/外派日期','propName':'dispatchDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'dispatchdate','iconName':'rqxzk','model':'vo.dispatchDate','option':[],'formTdAlign':'text-left','weekday':0}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_部门" class="el-table__cell tdlbl tdw13" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'department'" class="field">部门</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="department"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'部门','propName':'department','propType':'String','textFormatter':'textfield','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'department','iconName':'puwb','model':'vo.department','option':[],'formTdAlign':'text-left','autocomplete':'off','dialog':1,'showWordLimit':false,'dialogType':'suborg','dialogOrgLevel':'','formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_任职类别" class="el-table__cell tdlbl tdw13" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'jobCategory'" class="field">任职类别</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="jobCategory"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：主负责人\n1：副负责人\n2：普通员工','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'任职类别','propName':'jobCategory','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'jobcategory','iconName':'xialakuang','model':'vo.jobCategory','option':[{'value':'0','name':'主负责人'},{'name':'副负责人','value':'1'},{'name':'普通员工','value':'2'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false,'formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_职位" class="el-table__cell tdlbl tdw13" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'position'" class="field">职位</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="position"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'职位','propName':'position','propType':'String','textFormatter':'textfield','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'position','iconName':'puwb','model':'vo.position','option':[],'formTdAlign':'text-left','autocomplete':'off','dialog':0,'showWordLimit':false,'formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                    </tr>
                    <tr>
                        <td ref="tdlbl_职级" class="el-table__cell tdlbl tdw13" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'rank'" class="field">职级</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="rank"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'职级','propName':'rank','propType':'String','textFormatter':'textfield','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'rank','iconName':'puwb','model':'vo.rank','option':[],'formTdAlign':'text-left','dialog':1,'dialogType':'jobPosition','dialogOrgLevel':'','formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_排序编号" class="el-table__cell tdlbl tdw13" colspan="1">

                            <span v-field-lbl="'fileNumber'" class="field">排序编号</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="fileNumber"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'排序编号','propName':'fileNumber','propType':'String','textFormatter':'textfield','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'filenumber','iconName':'puwb','model':'vo.fileNumber','option':[],'formTdAlign':'text-left','autocomplete':'off','dialog':0,'showWordLimit':false}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                        <td ref="tdlbl_编制部门" class="el-table__cell tdlbl tdw13" colspan="1">
                            <span class="required">*</span>
                            <span v-field-lbl="'establishment'" class="field">编制部门</span>
                        </td>
                        <td class="el-table__cell tdcont tdw20" colspan="1">
                            <form-item
ref="establishment"
                                :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：是\n1：否','elementReadonly':1,'elementType':'radio','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'编制部门','propName':'establishment','propType':'String','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'tbFieldName':'establishment','iconName':'dxk','model':'vo.establishment','option':[{'value':'0','name':'是'},{'name':'否','value':'1'}],'formTdAlign':'text-left','optionGenerateType':0,'clearable':false,'filterable':false,'allowCreate':false,'formTdColspan':8}"
                                :vo="vo" :can-edit="canEdit"
/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 }
    },
    data: function() {
        return {
            loginUser: this.$store.getters.loginUser,
            activeTabName: 'User',
            vo: {
                name: ''
            }
        }
    },
    computed: {},
    watch: {},
    created: function() {
        // if(this.$parent.$vnode.context.activeTabIndex){
        //     this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        // }

        // this.$set(this.$vnode.context,"wfAttach",false)
    },
    beforeDestroy: function() {},
    mounted: function() {},
    methods: {
        ///detailedAppointment 详细信息
        submit() {
            this.vo.dispatchDate = moment(this.vo.dispatchDate).format('YYYY-MM-DD')
            this.vo.confirmationDate = moment(this.vo.confirmationDate).format('YYYY-MM-DD')
            this.vo.entryDate = moment(this.vo.entryDate).format('YYYY-MM-DD')
            console.log('this.rowDetial', this.vo)
            this.$http({
                	method: 'post',
                	url: '/xsgl/teacherAppointmentInfo/insert',
                	data: this.vo
            }).then(res => {
                	if (res.code === 'success') {
                		this.$message.success(res.message)
                	} else {
                		this.$message.error(res.message)
                	}
                if (type == 1) {
                    this.dialogFormVisible = false
                }
            })
        }
    }
}
</script>

<style scoped>
    .header {
        padding: 10px 20px;
        background-color: #f2f5fb;
        font-size: 15px;
    }
    .el-table {
        width: 100%;
    }
    .tdlbl {
        text-align: right;
        padding-right: 5px;
        font-weight: 700;
    }
</style>
